/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type RsiPageKindEnum = typeof RsiPageKindEnum[keyof typeof RsiPageKindEnum];


export const RsiPageKindEnum = {
  HANGAR: 'hangar',
  BUYBACK: 'buyback',
} as const;
